import { filterKeysArr } from '@/constants/catalogFilter';
import { getParamsObject } from '@/utils/urlQueryParams';

export default function getFiltersFromUrl<FILTER_KEY extends string>(
  url: string
): Partial<Record<FILTER_KEY, Set<string>>> {
  const objectUrl = getParamsObject(url);
  // delete the trailing brackets []
  const validFilters = filterKeysArr.reduce((acc, filter) => {
    const urlFilterName = `${filter}[]`;
    const urlFilterItem = objectUrl[urlFilterName];
    const urlFilterValue =
      typeof urlFilterItem === 'string' ? [urlFilterItem] : urlFilterItem;

    const filterSet = new Set();
    if (urlFilterValue) {
      urlFilterValue.forEach(value => {
        filterSet.add(value);
      });
    }
    acc[filter] = filterSet;

    return acc;
  }, {});
  return validFilters;
}
